<template>
    <div id="pageProperty">
        <a-row>
            <a-col :span="4" style="width: 200px;">
                <a-row class="ml4tb">
                    <a-button type="primary" size="small" @click="saveLeftPageProPerty">Save</a-button>
                    <a-tooltip placement="top" class="ml4">
                        <template slot="title">
                            <span>Displayable</span>
                        </template>
                        <a-switch size="small" @change="pagePertySwitchChange($event,'d')"/>
                    </a-tooltip>
                    <a-tooltip placement="top" class="ml4">
                        <template slot="title">
                            <span>Edit</span>
                        </template>
                        <a-switch size="small" @change="pagePertySwitchChange($event,'e')"/>
                    </a-tooltip>
                    <a-tooltip placement="top" class="ml4">
                        <template slot="title">
                            <span>Mandatory</span>
                        </template>
                        <a-switch size="small" @change="pagePertySwitchChange($event,'m')"/>
                    </a-tooltip>
                    <a-tooltip placement="top" class="ml4">
                        <template slot="title">
                            <span>Search</span>
                        </template>
                        <a-switch size="small" @change="pagePertySwitchChange($event,'s')"/>
                    </a-tooltip>
                </a-row>
                <a-col style="height: 80vh;overflow-y: auto">
                    <draggable class="list-group" :list="pagePropertylist" >
                        <div
                                class="list-group-item"
                                v-for="(element) in pagePropertylist"
                                :key="element.uid"
                                :class="{'active-color1':leftTargetUid == element.uid}">
                            <a-row type="flex" justify="start">
                                <a-col>
                                    <a-tooltip placement="top">
                                        <template slot="title">
                                            <span>Displayable</span>
                                        </template>
                                        <a-switch size="small" v-model="element.displayable"/>
                                    </a-tooltip>
                                    <a-tooltip placement="top">
                                        <template slot="title">
                                            <span>Edit</span>
                                        </template>
                                        <a-switch class='ml4' size="small" v-model="element.editable"/>
                                    </a-tooltip>
                                    <a-tooltip placement="top">
                                        <template slot="title">
                                            <span>Mandatory</span>
                                        </template>
                                        <a-switch class='ml4' size="small" v-model="element.mandatory"/>
                                    </a-tooltip>
                                    <a-tooltip placement="top">
                                        <template slot="title">
                                            <span>Search</span>
                                        </template>
                                        <a-switch class='ml4' size="small"  v-model="element.searchable"/>
                                    </a-tooltip>
                                </a-col>
                            </a-row>
                            <a-row type="flex" justify="start" class="sbxs" >
                                <a-tooltip placement="top">
                                    <template slot="title">
                                        <span>{{ element.fieldName }}</span>
                                    </template>
                                    <span style="text-decoration:underline;line-height: 25px" class="sbxs" @click="listClick(element)">{{ element.fieldName }}</span>
                                </a-tooltip>
                            </a-row>
                        </div>
                    </draggable>
                </a-col>
            </a-col>
            <a-col :span="16" class="padding4">
                <a-tabs>
                    <a-tab-pane key="1" tab="Basic">
                        <a-form :form="basicForm" class="mtb8">
                            <a-row>
                                <a-col :span="12"><a-form-item label="Column Width" v-bind="formItemLayout">
                                    <a-input
                                            autocomplete="off"
                                            size="small"
                                            v-decorator="[
                                              'columnWidth',
                                              {
                                                  initialValue: basicDeatilVal.columnWidth
                                              }
                                            ]"/>
                                </a-form-item></a-col>
                                <a-col :span="12"><a-form-item label="Default Value" v-bind="formItemLayout">
                                    <a-input
                                            autocomplete="off"
                                            size="small"
                                            v-decorator="[
                                          'defaultVal',
                                          {
                                              initialValue: basicDeatilVal.defaultVal,
                                                rules: [{max: 50}]
                                          }
                                        ]"/>
                                </a-form-item></a-col>
                                <a-col :span="12"><a-form-item label="Show Title Seq" v-bind="formItemLayout">
                                    <a-input-number
                                            size="small"
                                            style="width: 100%;"
                                            v-decorator="[
                                          'showTitleSeq',
                                          {
                                              initialValue: basicDeatilVal.showTitleSeq
                                          }
                                        ]"/>
                                </a-form-item></a-col>
                                <a-col :span="12"><a-form-item label="Is Title Shown" v-bind="formItemLayout">
                                    <a-switch
                                            size="small"
                                            v-decorator="[
                                          'isShowTitle',
                                          {
                                              initialValue: basicDeatilVal.isShowTitle == 'true' ? true : false,
                                              valuePropName: 'checked'
                                          }
                                        ]"/>
                                </a-form-item></a-col>

                                <a-col :span="12">
                                    <a-form-item label="Field Type" v-bind="formItemLayout">
                                        <a-select
                                            size="small"
                                            style="width: 100%"
                                            @change="fieldTypeChange"
                                            v-decorator="[
                                              'fieldType',
                                              { initialValue: basicDeatilVal.fieldType,}
                                            ]">
                                            <a-select-option :value="item" v-for="item in fieldTypeSelectData" :key="item">{{item}}</a-select-option>
                                        </a-select>
                                   </a-form-item>
                                </a-col>

                                <a-col :span="12"><a-form-item label="Like" v-bind="formItemLayout">
                                  <a-switch
                                      size="small"
                                      @change="likeChange"
                                      v-decorator="[
                                            'isSupportLike',
                                            {
                                                initialValue: basicDeatilVal.isSupportLike == '1' ? true : false,
                                                valuePropName: 'checked'
                                            }
                                          ]"/>
                                </a-form-item></a-col>

                                <a-col :span="12" v-if="isDropDown"><a-form-item label="Code Group" v-bind="formItemLayout">
                                    <a-input
                                            autocomplete="off"
                                            size="small"
                                            v-decorator="[
                                          'codeGroup',
                                          {
                                              initialValue: basicDeatilVal.codeGroup,
                                                rules: [{max: 50}]
                                          }
                                        ]"/>
                                </a-form-item></a-col>




                                <a-col :span="12"><a-form-item label="Field Length" v-bind="formItemLayout" v-if="isShowFiledLength">
                                    <a-input-number
                                            :formatter="value => `$ ${value}`.replace(/^(0+)|[^\d]/g, '')"
                                            :parser="value => value.replace(/^(0+)|[^\d]/g, '')"
                                            :min="0"
                                            size="small"
                                            style="width: 100%;"
                                            v-decorator="[
                                              'fieldLength',
                                              {
                                                  initialValue: basicDeatilVal.fieldLength,
                                              }
                                            ]"/>
                                </a-form-item></a-col>
                                <a-col :span="12"><a-form-item label="Field Length Digit" v-bind="formItemLayout" v-if="isShowFieldDigi">
                                    <a-input-number
                                            :formatter="value => `$ ${value}`.replace(/^(0+)|[^\d]/g, '')"
                                            :parser="value => value.replace(/^(0+)|[^\d]/g, '')"
                                            :min="0"
                                            size="small"
                                            style="width:100%;"
                                            v-decorator="[
                                              'fieldLengthDigit',
                                              {
                                                  initialValue: basicDeatilVal.fieldLengthDigit,
                                              }
                                            ]"/>
                                </a-form-item></a-col>





                                <!--                                :value="JSON.stringify(pageProPatterJson)"-->
                                <a-col :span="24">
                                    <a-form-item :label="$t('generic.FieldPattern')" :labelCol="{ span: 4 }">
                                        <div style="display: flex;align-items: center">
                                            <a-textarea
                                                    :placeholder="$t('generic.FieldPattern')"
                                                    size="small"
                                                    :rows="3"
                                                    style="width:70%"
                                                    disabled
                                                    :value="JSON.stringify(pageProPatterJson)"
                                            />
                                            <img  @click="editFieldPatterJson" class="sbxs mllr4" src="../../../assets/img/ss-add.png"  width="22" height="22">
                                            <img  @click="clearFieldPatter" class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
                                        </div>
                                    </a-form-item>
                                </a-col>




                            </a-row>
                            <a-row>
                                <a-button class="fr" type="primary" size="small" @click="saveBasic">Save</a-button>
                            </a-row>
                        </a-form>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="Multilingual">
                        <multilngual :leftTargetUid="leftTargetUid"></multilngual>
                    </a-tab-pane>
                </a-tabs>
            </a-col>
        </a-row>






        <a-modal
                :title="$t('generic.FieldPattern')"
                v-model="configPatterVis"
                width="60%"
                :maskClosable="maskClosable"
                @cancel="cancelFiledPattern"
        >
            <template slot="footer">
                <a-button type="primary" @click="getFiledPatterJson">{{ $t('publicLang.Save') }}</a-button>
            </template>

            <a-form :form="pageProPatternForm" ref="pageProPatternRef">
                <a-row :gutter="24">
                    <a-col :span="12">
                        <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
                            <a-cascader
                                    :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                                    size="small"
                                    :options="gmcuidModule"
                                    expandTrigger="hover"
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-model="ConfigGmcModule"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item :label="$t('generic.Function')" v-bind="formItemLayout">
                            <a-select
                                    style="width: 100%"
                                    allowClear
                                    showSearch
                                    size="small"
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-model="ConfigGmcFunction"
                            >
                                <a-select-option
                                        v-for="(item, index) in gmcuidfunction"
                                        :value="item.functionKey"
                                        :key="index"
                                >{{ item.functionValue }}</a-select-option
                                >
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item :label="$t('generic.GenericName')" v-bind="formItemLayout">
                            <a-select
                                    showSearch
                                    optionFilterProp="children"
                                    :filterOption="filterOption"
                                    allowClear
                                    style="width: 100%"
                                    size="small"
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    @dropdownVisibleChange="($event) =>{$event ? genericNameVisibleChange() : null }"
                                    v-decorator="[
                  'gmcUid',
                  { initialValue: pageProPatterJson.gmcUid }
                ]"
                            >
                                <a-select-option
                                        v-for="(item, index) in gmcuidGeneric"
                                        :value="item.uid"
                                        :key="index"
                                >{{ item.name }}</a-select-option
                                >
                            </a-select>
                        </a-form-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-item :label="$t('generic.GenericParameters')" v-bind="formItemLayout">
                            <a-select
                                    allowClear
                                    size="small"
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="[
                  'params',
                  {
                    initialValue:
                      pageProPatterJson.params == null
                        ? []
                        : pageProPatterJson.params,
                    rules: [{ type: 'array' }]
                  }
                ]"
                                    mode="multiple"
                            >
                                <a-select-option
                                        v-for="(item, index) in ParametersList"
                                        :value="item.detailUid"
                                        :key="index"
                                >{{ item.FieldName }}</a-select-option
                                >
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item :label="$t('generic.DefaultSelected')" v-bind="formItemLayout">
                            <a-switch
                                    size="small"
                                    v-decorator="[
                  'defaultSelected',
                  {
                      initialValue: pageProPatterJson.defaultSelected,
                      valuePropName: 'checked'
                  }
                ]"/>
                        </a-form-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-item :label="$t('generic.IsReserveAdmin')" v-bind="formItemLayout">
                            <a-switch
                                    size="small"
                                    v-decorator="[
                    'reserveAdmin',
                    {
                        initialValue: pageProPatterJson.reserveAdmin,
                        valuePropName: 'checked'
                    }
                ]"/>
                        </a-form-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-item :label="$t('generic.TitleInfo')" v-bind="formItemLayout">
                            <a-textarea size="small" :placeholder="$t('generic.TitleInfo')" :rows="2"
                                        v-decorator="[
                    'titleInfo',
                    {
                        initialValue: pageProPatterJson.titleInfo,
                    }
                ]"
                            />
                        </a-form-item>
                    </a-col>



                    <a-col :span="24">
                        <a-divider  style="margin: 10px 0"/>
                    </a-col>

                    <a-col :span="12">
                        <a-form-item :label="$t('generic.UniqueParameter')" v-bind="formItemLayout">
                            <a-select
                                    allowClear
                                    size="small"
                                    mode="multiple"
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="[
                  'uniqueParams',
                  {
                    initialValue:
                      pageProPatterJson.uniqueParams == null
                        ? []
                        : pageProPatterJson.uniqueParams,
                    rules: [{ type: 'array' }]
                  }
                ]"
                            >
                                <a-select-option
                                        v-for="(item, index) in ParametersList"
                                        :value="item.detailUid"
                                        :key="index"
                                >{{ item.FieldName }}</a-select-option
                                >
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item :label="$t('generic.Depend')" v-bind="formItemLayout">
                            <a-select
                                    style="width: 100%"
                                    allowClear
                                    size="small"
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="[
                  'dependOn',
                  {
                    initialValue: parseInt(pageProPatterJson.dependOn)
                  }
                ]"
                            >
                                <a-select-option
                                        v-for="(item, index) in ParametersList"
                                        :value="item.detailUid"
                                        :key="index"
                                >{{ item.FieldName }}</a-select-option
                                >
                            </a-select>
                        </a-form-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-item :label="$t('generic.Condition')" v-bind="formItemLayout">
                            <a-select
                                    style="width: 100%"
                                    allowClear
                                    size="small"
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="[
                  'condition',
                  {
                    initialValue: pageProPatterJson.condition
                  }
                ]"
                            >
                                <a-select-option value="<"> < </a-select-option>
                                <a-select-option value="="> = </a-select-option>
                                <a-select-option value=">"> > </a-select-option>
                                <a-select-option value="<>"> <> </a-select-option>
                                <a-select-option value=">="> >= </a-select-option>
                                <a-select-option value="<="> <= </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-item :label="$t('generic.IsDefType')" v-bind="formItemLayout">
                            <a-select
                                    style="width: 100%"
                                    size="small"
                                    allowClear
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="[
                  'isDefType',
                  {
                    initialValue: pageProPatterJson.isDefType
                  }
                ]"
                            >
                                <a-select-option value="Date"> Date </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>

                </a-row>
            </a-form>
            <a-row :gutter="24">
                <a-col :span="24">
                    <a-divider  style="margin: 10px 0">{{ $t('generic.ConfigurationMethod') }}</a-divider>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('generic.CalcParameters')" v-bind="formItemLayout">
                        <a-select
                                allowClear
                                size="small"
                                mode="multiple"
                                style="width: 100%"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                v-model="computeJson.computeMultiple"
                        >
                            <a-select-option
                                    v-for="(item, index) in ParametersList"
                                    :value="item.detailUid"
                                    :key="index"
                            >{{ item.FieldName }}</a-select-option
                            >
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('generic.CalcType')" v-bind="formItemLayout">
                        <a-select
                                style="width: 100%"
                                size="small"
                                v-model="computeJson.computeTypeTop"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                allowClear>
                            <a-select-option value="+">+</a-select-option>
                            <a-select-option value="*">*</a-select-option>
                            <a-select-option value="/">/</a-select-option>
                            <a-select-option value="DAY_OF_WEEK">DAY_OF_WEEK</a-select-option>
                            <a-select-option value="DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP">DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP</a-select-option>
                            <a-select-option value="ISO_YEAR_WEEK">ISO_YEAR_WEEK</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('generic.SurfixParameter')" v-bind="formItemLayout">
                        <a-input-number
                                style="width: 100%"
                                size="small"
                                v-model="computeJson.computeTypeNum"
                                :placeholder="$t('generic.SurfixParameter')"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('generic.CalcType')" v-bind="formItemLayout">
                        <a-select
                                style="width: 100%"
                                size="small"
                                v-model="computeJson.computeTypeBtm"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                allowClear>
                            <a-select-option value="+">+</a-select-option>
                            <a-select-option value="*">*</a-select-option>
                            <a-select-option value="/">/</a-select-option>
                            <a-select-option value="DAY_OF_WEEK">DAY_OF_WEEK</a-select-option>
                            <a-select-option value="DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP">DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP</a-select-option>
                            <a-select-option value="ISO_YEAR_WEEK">ISO_YEAR_WEEK</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-divider  style="margin: 10px 0">{{ $t('generic.ComputationalEvent') }}</a-divider>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('generic.TriggerFields')" v-bind="formItemLayout">
                        <a-select
                                allowClear
                                mode="multiple"
                                style="width: 100%"
                                size="small"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                v-model="computeJson.transmitParams">
                            <a-select-option
                                    v-for="(item, index) in ParametersList"
                                    :value="item.detailUid"
                                    :key="index"
                            >{{ item.FieldName }}</a-select-option
                            >
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item :label="$t('generic.IsTrigger')" v-bind="formItemLayout">
                        <a-switch v-model="computeJson.configChange"  size="small" @change="computeJsonIsChange"/>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-modal>




    </div>
</template>
<script>
    import { mapState } from "vuex";
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import draggable from "vuedraggable"
    import multilngual from './multilingual.vue'
    export default {
        props: {
            targetProgenericUid: {
                type: String,
                default: function () {
                    return '';
                }
            },
            proGenericHeaderInfo: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        components: {
            draggable,
            multilngual
        },
        data(){
            return{
                computeJson:{
                    computeMultiple: undefined,
                    computeTypeTop: undefined,
                    computeTypeNum: '',
                    computeTypeBtm: undefined,
                    configChange: false,
                    transmitParams: undefined
                },
                gmcuidGeneric: [],
                maskClosable: false, // 取消点击遮罩取消
                isDropDown: false,
                pagePropertylist: [],
                fieldTypeSelectData: [],
                isShowFiledLength: false,
                isShowFieldDigi: false,
                basicDeatilVal: {},
                leftTargetUid: null,
                formItemLayout: {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 8 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 }
                }
            },
                basicForm: this.$form.createForm(this),
                configPatterVis: false,
                ConfigGmcModule: [],
                ConfigGmcFunction: undefined,
                gmcuidModule: [],
                gmcuidfunction: [],
                ParametersList:[],
                pageProPatternForm: this.$form.createForm(this),
                pageProPatterJson: {},
            }
        },
        watch:{
            targetProgenericUid(){
                this.init()
            }
        },
        created(){
             this.init()
        },
        methods:{
            computeJsonIsChange(val){
                this.computeJson.configChange = val
            },
            genericNameVisibleChange() {
                let params = {
                    functionCode: this.ConfigGmcFunction,
                    moduleCode: this.ConfigGmcModule[0],
                    subModuleCode: this.ConfigGmcModule[1]
                };
                ajax.post(api.POSTFETCH, params).then(res => {
                    this.gmcuidGeneric = res.data;
                });
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            getFiledPatterJson() {
                this.pageProPatternForm.validateFields((err, val) => {
                    let getConfigJson = {};
                    let gmcName = undefined;
                    if (val.gmcUid != undefined) {
                        for (let ii in this.gmcuidGeneric) {
                            if (this.gmcuidGeneric[ii].uid == val.gmcUid) {
                                gmcName = this.gmcuidGeneric[ii].name;
                            }
                        }
                    }

                    getConfigJson = val;
                    getConfigJson.gmcName = gmcName;
                    getConfigJson.computeJson = this.computeJson
                    this.pageProPatterJson = getConfigJson;
                    this.pageProPatternForm.resetFields();
                    this.gmcuidGeneric = [];
                    this.configPatterVis = false;
                });
            },
            cancelFiledPattern() {
                this.pageProPatternForm.resetFields();
                this.gmcuidGeneric = [];
            },
            //          清楚配置
            clearFieldPatter() {
                this.pageProPatterJson = {};
            },
            editFieldPatterJson() {

                this.ConfigGmcModule = [];
                this.ConfigGmcFunction = undefined;
                ajax.get(api.GETMODULEDROPDATA).then(res => {
                    this.gmcuidModule = res.data;
                });
                ajax.get(api.GETFUNCTIONDROPDATA).then(res => {
                    this.gmcuidfunction = res.data;
                });

                let schemaParas = {
                    schemaUids: [],
                    uid: this.proGenericHeaderInfo.gmcUid
                };
                ajax.post(api.REFRESHPROPERTYDETAIL, schemaParas).then(res => {
                    this.ParametersList = res.data;
                });
                let params = {
                    functionCode: "",
                    moduleCode: "",
                    subModuleCode: ""
                };
                ajax.post(api.POSTFETCH, params).then(res => {
                    this.gmcuidGeneric = res.data;
                });

                this.configPatterVis = true;
            },

            pagePertySwitchChange(e,type){
                if(this.pagePropertylist.length > 0){
                    for(let i in this.pagePropertylist){
                        if(type =='e'){
                            this.pagePropertylist[i].editable = e
                        }
                        if(type =='d'){
                            this.pagePropertylist[i].displayable = e
                        }
                        if(type =='m'){
                            this.pagePropertylist[i].mandatory = e
                        }
                        if(type =='s'){
                            this.pagePropertylist[i].searchable = e
                        }
                    }
                }
            },
            init(){
                ajax.get(api.GENERICEXTGENERICPAGEPROPERTY,{geExtHeaderUid: this.targetProgenericUid}).then(res=>{
                    this.pagePropertylist = res.data.geExtDetailDtos
                    if(this.pagePropertylist.length > 0){
                        for(let i in this.pagePropertylist){
                            this.pagePropertylist[i].displayable = this.pagePropertylist[i].displayable == 1 ? true : false
                            this.pagePropertylist[i].editable = this.pagePropertylist[i].editable == 1 ? true : false
                            this.pagePropertylist[i].mandatory = this.pagePropertylist[i].mandatory == 1 ? true : false
                            this.pagePropertylist[i].searchable = this.pagePropertylist[i].searchable == 1 ? true : false
                        }
                        this.leftTargetUid = this.pagePropertylist[0].uid
                        this.basicDeatil()
                    }
                })
            },
            listClick(item){
                this.leftTargetUid = item.uid
                this.basicForm.resetFields()
                this.basicDeatil()

            },
            basicDeatil(){
                this.basicDeatilVal = {}
                ajax.get(api.GENERICEXTGENERICGEEXTDETAIL,{geExtDetailUid: this.leftTargetUid}).then(res=>{
                    this.basicDeatilVal = res.data
                    this.pageProPatterJson =  res.data.fieldPatternStr == null ? {}: JSON.parse(res.data.fieldPatternStr);
                    this.computeJson = this.pageProPatterJson.computeJson == null ? {} : this.pageProPatterJson.computeJson;
                    let item = this.basicDeatilVal
                    let fieldType = item.fieldType == null ? '' : item.fieldType.toLowerCase()
                    
 
                    if(fieldType == 'string' || fieldType == 'decimal' || fieldType == 'email' || fieldType == 'intege' ){
                        this.isShowFiledLength = true
                    }else{
                        this.isShowFiledLength = false
                    }
                    if(fieldType == 'decimal'){
                        this.isShowFieldDigi = true
                    }else{
                        this.isShowFieldDigi = false
                    }

                    if(fieldType == 'drop'){
                        this.isDropDown = true
                    }else{
                        this.isDropDown = false
                    }

                    if(fieldType == 'string' || fieldType == 'drop'){
                        this.fieldTypeSelectData = ['String','Decimal','Email','Date','Datetime','Integer','Boolean','Image','DROP']
                    }else if(fieldType == 'decimal'){
                        this.fieldTypeSelectData = ['Decimal','Integer']
                    }else if(fieldType  == 'email'){
                        this.fieldTypeSelectData = ['Email']
                    }else if(fieldType  == 'datetime' || fieldType == 'date'){
                        this.fieldTypeSelectData =['Datetime','Date']
                    }else if(fieldType == 'integer'){
                        this.fieldTypeSelectData = ['Integer']
                    }else if(fieldType  == 'boolean'){
                        this.fieldTypeSelectData = ['Boolean']
                    }else if(fieldType  == 'image'){
                        this.fieldTypeSelectData = ['Image']
                    }
                })
            },
            saveBasic(){
                this.basicForm.validateFields((err,values)=>{
                    if (!err){
                        values.gmcUid = this.proGenericHeaderInfo.gmcUid
                        values.uid = this.leftTargetUid
                        values.isShowTitle =  values.isShowTitle ? 'true' : 'false'
                        values.displayable =  this.basicDeatilVal.displayable
                        values.isSupportLike =  values.isSupportLike ? '1' : '0'
                        values.fieldPattern = JSON.stringify(this.pageProPatterJson) === '{}' ? null :  this.pageProPatterJson
                        ajax.post(api.GENERICEXTGENERICGEEXTDETAIL,values).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })
            },
            saveLeftPageProPerty(){
                let data = JSON.parse(JSON.stringify(this.pagePropertylist))
                for(let i in data){
                    data[i].displayable = data[i].displayable ? '1' : '0'
                    data[i].editable = data[i].editable ? '1' : '0'
                    data[i].mandatory = data[i].mandatory ? '1' : '0'
                    data[i].searchable =data[i].searchable  ? '1' : '0'
                }
                ajax.post(api.GENERICEXTGENERICPAGEPROPERTY,{geExtDetailDtos: data}).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                    }
                })
            },
            fieldTypeChange(val){
              
                if(typeof(val) == 'string'){
                        val = (String(val)).toLowerCase(); // 转小写
                }
 
                if(val == 'string' || val == 'decimal' || val == 'email' || val == 'intege' ){
                    this.isShowFiledLength = true
                }else{
                    this.isShowFiledLength = false
                }
                if(val == 'decimal'){
                    this.isShowFieldDigi = true
                }else{
                    this.isShowFieldDigi = false
                }
              
                if(val == 'drop'){
                    this.isDropDown = true;
                }else{
                      this.isDropDown = false;
                }

            },
            likeChange(checked) {
              if(checked){
                if(this.basicDeatilVal.displayable == null || "1" != this.basicDeatilVal.displayable){
                  this.$customMessage.warning(this.$t('publicLang.PleaseCheckDisplayableFirst'));
                  this.$nextTick(() => {
                    this.basicForm.setFieldsValue({
                      isSupportLike: false
                    });
                  });
                }
              }
            },
        }
    }
</script>
<style  >
    .active-color1{
        background-color: #CCCCCC !important;;
        color: #fff;
    }
</style>